import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import "./Login.css";

const REMEMBER_KEY = "ct_login_user";

function greetingNow() {
  const h = new Date().getHours();
  if (h >= 5 && h < 12) return "Günaydın";
  if (h >= 12 && h < 18) return "İyi günler";
  return "İyi akşamlar";
}

export default function Login() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState(() => localStorage.getItem(REMEMBER_KEY) || "");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(() => Boolean(localStorage.getItem(REMEMBER_KEY)));
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const from = location.state?.from?.pathname || "/";
  const landing = user?.tenant_id != null && user.tenant_id !== "" ? "/tum-is-emirleri" : from;

  if (!loading && user) {
    return <Navigate to={landing} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const name = username.trim();
      const loggedIn = await login(name, password);
      if (remember) localStorage.setItem(REMEMBER_KEY, name);
      else localStorage.removeItem(REMEMBER_KEY);
      const scoped = loggedIn?.tenant_id != null && loggedIn.tenant_id !== "";
      navigate(scoped ? "/tum-is-emirleri" : from, { replace: true });
    } catch (err) {
      console.error(err);
      setError("Kullanıcı adı veya şifre hatalı");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="ct-login">
      <main className="ct-login__form-side">
        <img className="ct-login__logo" src="/assets/img/menu_logo.png" alt="Coiltech" />

        <div className="ct-login__card">
          <div className="ct-login__head">
            <span className="ct-login__eyebrow">Servis Portalı</span>
            <h1>Hesabınıza giriş yapın</h1>
            <p className="ct-login__sub">Devam etmek için kullanıcı bilgilerinizi girin.</p>
            {error ? <p className="ct-login__error">{error}</p> : null}
          </div>

          <form onSubmit={onSubmit}>
            <div className="ct-login__field">
              <label htmlFor="username">Kullanıcı adı</label>
              <div className="ct-login__input-wrap">
                <svg className="ct-login__ico" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="8" r="4" />
                  <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
                </svg>
                <input
                  id="username"
                  name="username"
                  className="ct-login__input"
                  type="text"
                  autoComplete="username"
                  placeholder="ornek.kullanici"
                  required
                  autoFocus
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
            </div>

            <div className="ct-login__field">
              <label htmlFor="password">Şifre</label>
              <div className="ct-login__input-wrap">
                <svg className="ct-login__ico" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="4" y="11" width="16" height="10" rx="2" />
                  <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                </svg>
                <input
                  id="password"
                  name="password"
                  className={`ct-login__input ct-login__input--pw`}
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  placeholder="••••••••"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="ct-login__toggle"
                  aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
                  aria-pressed={showPassword}
                  onClick={() => setShowPassword((value) => !value)}
                >
                  {showPassword ? (
                    <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M3 3l18 18" />
                      <path d="M10.6 6.1A10 10 0 0 1 12 6c6 0 10 6 10 6a17 17 0 0 1-3.2 3.8" />
                      <path d="M6.6 6.6A17 17 0 0 0 2 12s4 6 10 6a9.7 9.7 0 0 0 5.4-1.6" />
                      <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
                    </svg>
                  ) : (
                    <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <label className="ct-login__remember" htmlFor="remember">
              <input
                id="remember"
                name="remember"
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
              />
              Beni hatırla
            </label>

            <button type="submit" className="ct-login__btn" disabled={submitting || loading}>
              {submitting ? "Giriş yapılıyor…" : "Giriş yap"}
              <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14" />
                <path d="M13 6l6 6-6 6" />
              </svg>
            </button>
          </form>
        </div>

        <div className="ct-login__foot">
          <span>© {new Date().getFullYear()} Coiltech Teknoloji A.Ş.</span>
          <span className="ct-login__mono">v3.0.0</span>
        </div>
      </main>

      <aside className="ct-login__visual" aria-hidden="true">
        <svg className="ct-login__rings" width="760" height="760" viewBox="0 0 760 760" fill="none">
          <circle cx="380" cy="380" r="370" stroke="#FF5A00" strokeOpacity="0.10" strokeWidth="2" />
          <circle cx="380" cy="380" r="300" stroke="#FF5A00" strokeOpacity="0.16" strokeWidth="2" />
          <circle cx="380" cy="380" r="230" stroke="#FF5A00" strokeOpacity="0.24" strokeWidth="2" />
          <circle cx="380" cy="380" r="160" stroke="#FF5A00" strokeOpacity="0.38" strokeWidth="2" />
          <circle cx="380" cy="380" r="90" fill="#FF5A00" fillOpacity="0.85" />
          <circle cx="380" cy="380" r="44" fill="#F6F4F1" />
        </svg>

        <div className="ct-login__status">
          <span className="ct-login__dot" />
          Sistem çevrimiçi
        </div>

        <div className="ct-login__hero">
          <div className="ct-login__bar" />
          <div className="ct-login__greet">{greetingNow()}</div>
          <p>Makine servis kayıtları, arıza takibi ve uzaktan destek — tek panelde.</p>
          <div className="ct-login__chips">
            <span className="ct-login__chip">Servis talepleri</span>
            <span className="ct-login__chip">Arıza kayıtları</span>
            <span className="ct-login__chip">Uzaktan destek</span>
          </div>
        </div>
      </aside>
    </div>
  );
}
